
const digest = 'cf9e465582545ae3a8f00c12049b6059c4a9d06ca8ceee84f6faadbe75aa17fa';
const classes = {"wrapper":"_wrapper_1cxc7_1","date":"_date_1cxc7_10","content":"_content_1cxc7_20","title":"_title_1cxc7_28","cancelInfo":"_cancelInfo_1cxc7_32","controls":"_controls_1cxc7_38"};
const css = `._wrapper_1cxc7_1 {
  display: flex;
  flex-direction: row;
  position: relative;
  border-bottom: 1px solid #eaedf3;
}
._wrapper_1cxc7_1:last-of-type {
  border-bottom: 0;
}
._wrapper_1cxc7_1 ._date_1cxc7_10 {
  display: flex;
  border-right: 1px solid #eaedf3;
  padding: 24px;
  min-width: 200px;
  max-width: 200px;
  font-size: 14px;
  align-items: center;
  font-weight: 500;
}
._wrapper_1cxc7_1 ._content_1cxc7_20 {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  padding: 24px;
}
._wrapper_1cxc7_1 ._content_1cxc7_20 ._title_1cxc7_28 {
  font-size: 14px;
  font-weight: 500;
}
._wrapper_1cxc7_1 ._content_1cxc7_20 ._cancelInfo_1cxc7_32 {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  gap: 5px;
}
._wrapper_1cxc7_1 ._controls_1cxc7_38 {
  min-width: 200px;
  max-width: 200px;
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  gap: 16px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  